import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { RolRequest } from '@shared/interfaces/request/rolRequest';
import { SwalService } from '@shared/utils/swal.service';
import { RolService } from '@pages/rol/services/rol.service';
import { ConfirmDeletionComponent } from '@shared/components/confirm-deletion/confirm-deletion.component';
import { RolFormComponent } from '../rol-form/rol-form.component';

@Component({
  selector: 'app-rol',
  templateUrl: './rol.component.html',
  styleUrls: ['./rol.component.css'],
})
export class RolComponent implements OnInit {
  public columns: string[] = [
    'actions',
    'id',
    'description',
    'definition',
    'active',
    'userCreated',
    'dateCreated',
    'userModified',
    'dateModified'
  ];
  private readonly _width: string = '380px';
  public allData: number = 0;
  public loading: boolean = true;

  constructor(
    public _dialog: MatDialog,
    private _swalService: SwalService,
    private _rolServices: RolService
  ) {}

  ngOnInit(): void {
    this.read();
  }

  dataSource = new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  @ViewChild(MatSort) sort: MatSort;

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  read() {
    this._rolServices.read().subscribe((res) => {
      this.dataSource.data = res.data;
      if (res.data) this.allData = res.data.length;
      if (this.allData >= 0) this.loading = false;
    });
  }

  openCreate() {
    const dialogRef = this._dialog.open(RolFormComponent, {
      width: this._width,
    });
    dialogRef.afterClosed().subscribe((res) => {
      this.read();
    });
  }

  openUpdate(model: RolRequest) {
    const dialogRef = this._dialog.open(RolFormComponent, {
      width: this._width,
      data: model,
    });
    dialogRef.afterClosed().subscribe((res) => {
      this.read();
    });
  }

  delete(model: RolRequest) {
    const dialogRef = this._dialog.open(ConfirmDeletionComponent, {
      width: '310px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this._rolServices.delete(model).subscribe((res) => {
          if (res.exito === 1) {
            this.read();
            this._swalService.success('Eliminado');
          }else this._swalService.error('No Eliminado, el Rol puede estar asignado a un Usario y no es posible eliminar, por favor contacte el administrador.')
        });
      }
    });
  }
}
